import React from 'react';
import styled from 'styled-components';
import { Icon } from '@blueprintjs/core';
export const P = styled.p `
  background-color: red;
  padding: 20px;
  border-radius: 5px;
`;
export const Spaced = styled.div `
  display: flex;
  padding: 5px;
  align-items: center;
  > * {
    padding: 0 ${({ spacing }) => spacing};
  }
`;
export const CenteredContent = styled.div `
  display: flex;
  flex-direction: ${(props) => (props.horizontal ? 'row' : 'column')};
  align-items: center;
  padding: 1em;
  text-align: center;
`;
const HelpStyle = styled.div `
  border-radius: 5px;
  border: 1px solid var(--main-blue);
  background-color: var(--main-blue-lighter);
  display: flex;
  flex-direction: row;
  padding: 1em;
  align-items: center;
  margin-bottom: 1em;
`;
export const HelpBlock = ({ children, className, style }) => (React.createElement(HelpStyle, { className: className, style: style },
    React.createElement(Icon, { icon: 'help', style: { marginRight: '1em' } }),
    React.createElement("div", null, children)));
//# sourceMappingURL=Paragraph.js.map